module.exports = __webpack_public_path__ + "img/javascript_icon.bc786b35.svg";